// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_19ac3","content":"_8e4f2"};